<template>
  <boxwrap class="bet-history--inner">
    <toolbar>
      <toolbar-items class="-searchbar -withdropdown">
        <search
          class ="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="{'data-loading': showDataLoading}"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <div class="betslip__items">
        <betslip-card
          v-for="(slip, index) in betHistory"
          :key="index"
          :logs="slip"
          v-if="!isDataLoading"
          @update="update($event)"
        >
          <bets-card
            v-for="(bets, idx) in slip.userBets"
            :key="idx"
            :logs="bets"
            v-if="slip.userBets.length > 0"
          >
          </bets-card>
        </betslip-card>
      </div>

      <pagination
        :total="count"
        :limit="params.rows"
        v-model="params.page"
        :rows="params.rows"
        @page="trigger">
      </pagination>

    </boxwrap-contents>
  </boxwrap>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getStyles } from '@/assets/js/mixins/base/GetStyles'

import BetslipCard from '@/components/common/betslip/BetslipCard'
import BetsCard from '@/components/common/betslip/BetsCard'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  components: {
    BetslipCard,
    BetsCard,
    Pagination,
    Search,
    CheckDataList
  },

  filters: {},

  mixins: [ getStyles ],

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      filterBy: [
        {
          value: 'user_id',
          display: 'User ID'
        },
        {
          value: 'id',
          display: 'Betslip ID'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      status: '',
      filter: '',

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false
    }
  },

  computed: {
    ...mapState('bet-history',
      ['betHistory', 'count'])
  },

  watch: {
    filter () {
      this.resetParams()
      if (this.filter === '') {
        this.search()
      }
    },

    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  created () {
    this.params = this.generate(this.params)
    this.search()
  },

  methods: {
    ...mapActions('bet-history',
      ['get', 'restore', 'cancel', 'delete']),

    async resetParams () {
      this.params = {
        page: 1,
        rows: 50,
        sort_by: 'id',
        sort: 'desc',
        filter_by: '',
        q: '',
        date_from: '',
        date_to: ''
      }
    },

    async trigger (q) {
      this.params = q || this.params
      this.$router.push({ path: '/bet-history', query: this.params })
    },

    async search (q) {
      this.params = q || this.params
      this.status = this.$route.params.status

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get(this.params)

      this.isDataLoading = false
      this.showDataLoading = false

      if (!this.betHistory.length) {
        this.isEmpty = true
      }
    },

    setTableHeight () {
      this.$loaded(() => {
        this.tblConfig.table_h = this.boxwrapConfig.contents_h
      }, 3000)
    }
  }

}
</script>
